import React from 'react';

const HandWave = ({ className = "" }) => (
  <svg className={className} width="120" height="120" viewBox="0 0 120 120" fill="none">
    <path d="M30 60 Q 35 45, 45 40 L 50 35 Q 52 30, 48 28 Q 45 26, 42 28 L 38 35" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
    <path d="M45 40 L 55 30 Q 58 27, 60 30 Q 62 33, 58 37" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
    <ellipse cx="48" cy="65" rx="15" ry="20" stroke="currentColor" strokeWidth="2.5" fill="none"/>
    <circle cx="44" cy="60" r="2" fill="currentColor"/>
    <circle cx="52" cy="60" r="2" fill="currentColor"/>
    <path d="M42 68 Q 48 72, 54 68" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export default HandWave;